import StarSvgComponent from "@/components/Campaign/management/kpi/StarSvgComponent";
import clsxm from "@/lib/clsxm";
import {MAX_RATING_VALUE} from "@/store/constants";
import times from "lodash/times";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const InfluencerRatingSection: FC<{
  className?: string;
  contentQuality: number;
  contentQualityTitle?: string;
  firstName?: string;
  onRateQuality: (value: number) => void;
  onRateReliability: (value: number) => void;
  ratingClassName?: string;
  reliability: number;
  reliabilityTitle?: string;
  starClassName?: string;
  textClassName?: string;
}> = ({
  className,
  contentQuality,
  contentQualityTitle,
  firstName,
  onRateQuality,
  onRateReliability,
  ratingClassName,
  reliability,
  reliabilityTitle,
  starClassName,
  textClassName,
}) => {
  const {t} = useTranslation("campaign_reporting");

  const ratings = [
    {
      title: reliabilityTitle ?? t("reliability_title", {influencerName: firstName}),
      value: reliability,
      onRate: onRateReliability,
    },
    {
      title: contentQualityTitle ?? t("quality_title", {influencerName: firstName}),
      value: contentQuality,
      onRate: onRateQuality,
    },
  ];

  return (
    <div className={clsxm("flex flex-col gap-5", className)}>
      {ratings.map(({title, value, onRate}, index) => (
        <div key={index} className={clsxm("flex flex-col gap-2.5", ratingClassName)}>
          <span className={clsxm("text-neutral-black text-xl leading-5 font-semibold", textClassName)}>{title}</span>
          <div className="flex gap-0.5">
            {times(MAX_RATING_VALUE, idx => (
              <button key={idx} onClick={() => onRate(idx + 1)}>
                <StarSvgComponent index={idx} currentValue={value} className={clsxm("size-8.5", starClassName)} />
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default InfluencerRatingSection;
